export default function SkillDrag() {
  return (
    <svg
      width="10"
      height="18"
      viewBox="0 0 6 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1 1V0.999002L1.5 1H1ZM1 12C1.551 12 2 12.449 2 13C2 13.551 1.551 14 1 14C0.448007 14 7.12076e-06 13.551 7.12076e-06 13C7.12076e-06 12.449 0.448007 12 1 12ZM5 12C5.551 12 6 12.449 6 13C6 13.551 5.551 14 5 14C4.448 14 4 13.551 4 13C4 12.449 4.448 12 5 12ZM0.999993 8C1.55099 8 1.99999 8.449 1.99999 9C1.99999 9.551 1.55099 10 0.999993 10C0.448 10 0 9.551 0 9C0 8.449 0.448 8 0.999993 8ZM4.99999 8C5.55099 8 5.99999 8.449 5.99999 9C5.99999 9.551 5.55099 10 4.99999 10C4.44799 10 3.99999 9.551 3.99999 9C3.99999 8.449 4.44799 8 4.99999 8ZM0.999993 3.99999C1.55099 3.99999 1.99999 4.449 1.99999 4.99999C1.99999 5.55099 1.55099 5.99999 0.999993 5.99999C0.448 5.99999 0 5.55099 0 4.99999C0 4.449 0.448 3.99999 0.999993 3.99999ZM4.99999 3.99999C5.55099 3.99999 5.99999 4.449 5.99999 4.99999C5.99999 5.55099 5.55099 5.99999 4.99999 5.99999C4.44799 5.99999 3.99999 5.55099 3.99999 4.99999C3.99999 4.449 4.44799 3.99999 4.99999 3.99999ZM0.999993 0C1.55099 0 1.99999 0.448999 1.99999 1C1.99999 1.551 1.55099 2 0.999993 2C0.448 2 0 1.551 0 1C0 0.448999 0.448007 0 0.999993 0ZM4.99949 0C5.55049 0 5.99949 0.448999 5.99949 1C5.99949 1.551 5.55049 2 4.99949 2C4.4485 2 3.99949 1.551 3.99949 1C3.99949 0.448999 4.4485 0 4.99949 0Z"
        fill="#A9B4BE"
        strokeWidth="10"
      />
    </svg>
  );
}
